import { useGetFlagValue as useGetFlagValueBase } from '@resolve_medical_bills/flagsmith/react';
import type { QuestionnaireFlagKey } from './key';

// Narrows the shared hook to this app's flag keys.
export const useGetFlagValue = (reqFlag: QuestionnaireFlagKey) => useGetFlagValueBase(reqFlag);
